import { t } from 'i18next';
import { useCallback } from 'react';
import styled from 'styled-components';

import { MEDIA_QUERIES } from '#/hooks';
import { generalModalStoreActions, useGeneralModalStore } from '#/store/modals';

import Button from '../Button/Button';
import { Modal } from './Modal';

/** Component responsible for showing validation error messages. It works with in pair with `useModal` hook */
export const GenericModal = () => {
  const {
    isModalVisible,
    opts: { message, buttonLabel = t('button.ok'), title, onDismiss, onOk },
  } = useGeneralModalStore();

  const closeModal = useCallback(() => {
    generalModalStoreActions.hideModal();
    onDismiss?.();
  }, [onDismiss]);

  return (
    <StyledModal
      closeOnEsc
      closeOnOverlayClick
      isOpen={isModalVisible}
      onClose={closeModal}
      showCloseButton
    >
      {title && <h2>{title}</h2>}
      {message}
      <Actions>
        <Button onClick={onOk || closeModal}>{buttonLabel}</Button>
      </Actions>
    </StyledModal>
  );
};

const Actions = styled.div`
  margin-top: 1rem;
`;

const StyledModal = styled(Modal)`
  padding-top: 2.5rem;
  min-width: 20rem;
  max-width: 40rem;

  @media (${MEDIA_QUERIES.xs}) {
    min-width: initial;
  }
`;
